import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { EventDiscoveryPageProps } from './components/EventDiscoveryPageContentWrapper';

const EventDiscoveryPageContentWrapper = lazy(
  () => import('./components/EventDiscoveryPageContentWrapper'),
);

export const EventDiscoveryPageV2 = wrapLazyNavigatorScreen(
  (props: EventDiscoveryPageProps) => {
    return <EventDiscoveryPageContentWrapper {...props} />;
  },
  { headerShown: false },
);

export default EventDiscoveryPageV2;
